module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-range-fill-af7e2f24.svg";